var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fxt-app-why-box"},[_c('div',{staticClass:"fxt-app-why-box-icon",domProps:{"innerHTML":_vm._s(_vm.obj.svg)}}),_c('h4',[_vm._v(_vm._s(_vm.obj.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }